import React from 'react';
import { Avatar as AntAvatar } from 'antd';
import type { AvatarProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Avatar (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-avatar` class hook.
 */
export const Avatar = ({ className, ...props }: AvatarProps) => (
  <AntAvatar {...props} className={clsx('wk-avatar', className)} />
);

Avatar.Group = AntAvatar.Group;
